import styled from 'styled-components';

import { Skeleton } from '@soluto-private/mx-asurion-ui-react';

import { useAddressToLatLong } from '@service-initiation/shared-data-access-google';
import {
  GoogleMap as GoogleMapBase,
  GoogleMapMarker,
} from '@service-initiation/shared-ui-google-map';

import { ReactComponent as MarkerIconBase } from './assets/marker-icon.svg';

const GoogleMap = styled(GoogleMapBase)`
  height: 200px;
`;

const MarkerIcon = styled(MarkerIconBase)`
  height: 13.5px;
`;

export type MapProps = {
  address: string;
};

export const Map = ({ address }: MapProps) => {
  const { loading, value } = useAddressToLatLong(address);

  return loading || !value ? (
    <Skeleton height="200px" />
  ) : (
    <GoogleMap defaultCenter={value} defaultZoom={11}>
      <GoogleMapMarker lat={value.lat} lng={value.lng}>
        <MarkerIcon />
      </GoogleMapMarker>
    </GoogleMap>
  );
};
